export enum QRCodeElementType {
  Canvas = 'canvas',
  Svg = 'svg',
  Image = 'image',
  Url = 'url'
}
